var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "2102E158-C6F3-42DD-8156-B5BC384B244B")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 9.09494702e-13,
    y: 0,
    width: 940,
    height: 767
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-1.0%",
    width: "102.1%",
    height: "102.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-1.7%",
    y: "-1.8%",
    width: "103.4%",
    height: "104.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.844259511   0 0 0 0 0.844259511   0 0 0 0 0.844259511  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 0,
    y: 0,
    width: 940,
    height: 60
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-10.8%",
    width: "101.8%",
    height: "128.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.910297781   0 0 0 0 0.910297781   0 0 0 0 0.910297781  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Calendar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Day-w-List",
    transform: "translate(-57.000000, -95.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8FAFD",
    x: 0,
    y: 0,
    width: 1024,
    height: 878
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(42.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    filter: "url(#filter-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calendar-menu-Copy",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Add-file",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 18,
    y2: 4,
    id: "Path-5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 16,
    y2: 8,
    id: "Path-5-Copy",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 16,
    y2: 16,
    id: "Path-5-Copy-2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 1,
    x2: 18,
    y2: 1,
    id: "Path-5-Copy-2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "currentColor",
    cx: 1,
    cy: 1,
    r: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "currentColor",
    cx: 1,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    cx: 1,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "currentColor",
    cx: 1,
    cy: 8,
    r: 1
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list.f5fb246f.svg";
export { ForwardRef as ReactComponent };